import React from "react";
import PageHero from "@/components/PageHero";
import FinalCTA from "@/components/FinalCTA";
import SectionHeading from "@/components/SectionHeading";
import { Heart, GraduationCap, Building2, Mail, IndianRupee, Phone } from "lucide-react";

const PROGRAMS = [
  { icon: Heart, title: "Senior Citizen Safety", desc: "Friendly, vernacular awareness sessions for elders — focused on UPI, OTP and call-spoofing scams." },
  { icon: GraduationCap, title: "School Cyber Awareness", desc: "Engaging modules for students — online safety, gaming risks, social media hygiene and reporting." },
  { icon: Building2, title: "Corporate Awareness Programs", desc: "Continuous training with phishing simulation, micro-learning and culture metrics." },
  { icon: Mail, title: "Phishing Awareness", desc: "Identify, report and avoid phishing with practical, role-based scenarios." },
  { icon: IndianRupee, title: "UPI Scam Awareness", desc: "Real cases, fake screens and counter-measures — for individuals and small merchants." },
  { icon: Phone, title: "1930 Cyber Helpline Awareness", desc: "How to report cybercrime to India's 1930 helpline and recover stolen funds quickly." },
];

export default function Awareness() {
  return (
    <div data-testid="awareness-page">
      <PageHero
        eyebrow="Awareness Initiative"
        title="Creating a Safer Digital Society"
        description="From boardrooms to classrooms to living rooms — our awareness programs reach every layer of the digital society."
      />

      <section className="py-20 bg-white">
        <div className="container-cd">
          <SectionHeading eyebrow="Programs" title="A program for every audience" />
          <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {PROGRAMS.map((p, i) => (
              <div key={p.title} className="card-cd" data-testid={`awareness-program-${i}`}>
                <span className="h-12 w-12 grid place-items-center rounded-xl bg-gradient-to-br from-cyan-500/10 to-blue-500/10 border border-cyan-100">
                  <p.icon size={22} className="text-[#3B82F6]" strokeWidth={1.6} />
                </span>
                <h3 className="mt-5 font-display text-xl font-bold text-[#0A1B5E]">{p.title}</h3>
                <p className="mt-3 text-slate-600 text-[15px] leading-relaxed">{p.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <FinalCTA />
    </div>
  );
}
